import { useEffect, useRef, useContext } from "react";
import { Row, Col } from "antd";
import { gsap } from "gsap";
import { UserDataContext } from "../context/User";
import { useNavigate } from "react-router-dom";

function Banner({
  backgroundImage,
  heading,
  paragraph,
  bton,
  minHeight = "100vh",
  width="100%",
  padding = "50px 0",
  headingClass = "text-[#fff] text-[30px] sm:text-[40px] lg:text-[60px] font-cinzel",
  paragraphClass = "text-[14px] sm:text-[18px] lg:text-[20px] text-[#fff] font-outfit mt-4",
  containerClass = "",
 }) {
  const navigate = useNavigate();
  const bannerRef = useRef(null);
  const headingRef = useRef(null);
  const paragraphRef = useRef(null);
  const btonRef = useRef(null);
  const { userData } = useContext(UserDataContext);
  const isLoggedIn = userData?.id;
  const isMobile = window.innerWidth < 768;
  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

      tl.from(bannerRef.current, {
        scale: 0.95,
        opacity: 0,
        duration: 0.8,
      });

      tl.from(
        headingRef.current,
        {
          y: 50,
          opacity: 0,
          duration: 0.8,
        },
        "-=0.4"
      );

      tl.from(
        paragraphRef.current,
        {
          y: 30,
          opacity: 0,
          duration: 0.7,
        },
        "-=0.5"
      );
    }, bannerRef);

    return () => ctx.revert();
  }, []);

  const handleClick = () => {
    navigate("/login");
  };

  return (
    <div>
      <div
        ref={bannerRef}
        className={`banner ${containerClass}`}
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding,
          minHeight,
          width,
          position: "relative",
          zIndex: 0,
        }}
      >
        <div className="container  w-full px-4">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className="flex flex-col items-center justify-center text-center">
                <h2 ref={headingRef} className={headingClass}>
                  {heading}
                </h2>
                <p ref={paragraphRef} className={paragraphClass}>
                  {paragraph}
                </p>

                {!isLoggedIn && (
                   <button
          onClick={handleClick}
          className="mt-[45px] text-black font-outfit font-semibold px-6 py-3 rounded-full 
             shadow-md transition-all duration-500 bg-gradient-to-r from-[#00F0FB] via-white to-[#00F0FB]
             bg-[length:200%_200%] bg-left hover:bg-right hover:scale-105"
        >
         {bton}
        </button>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default Banner;
